import React from 'react';
import { SelectedTag } from './@components/SelectedTag';
import { FilterChipProps } from './@types';

export const getSelectedTags = ({
  type,
  selected,
  color,
}: FilterChipProps): React.ReactElement | React.ReactElement[] | undefined => {
  if (!selected) return;

  if (type === 'other') {
    // other type 일 경우 selected 에 출력할 label 만 전달받음
    return <SelectedTag color={color}>{selected}</SelectedTag>;
  }

  return;
};
